<template>
  <div
    class="
      bg-white w-full
      fixed bottom-0 left-0 right-0 z-[500]
      border-t
      grid grid-cols-4
    "
    >
    <ui-link
      :class="[
        isRouteActive('/home')
          ? 'navpoint text-secondary'
          : 'navpoint text-gray-400',
      ]"
      to="/home"
      >
      <i class="fas fa-home cursor-pointer text-xl" />
      <small
        class="truncate"
        v-text="t('Home')"/>
    </ui-link>


    <ui-link
      :class="[
        isRouteActive('/home/school/simulator')
          ? 'navpoint text-secondary'
          : 'navpoint text-gray-400',
      ]"
      to="/home/school/simulator"
      >
      <i class="fas fa-plane cursor-pointer text-xl" />
      <small class="truncate" v-text="t('Simulator')"/>
    </ui-link>


    <ui-link
      :class="[
        isRouteActive('/home/school')
          ? 'navpoint text-secondary'
          : 'navpoint text-gray-400',
      ]"
      to="/home/school"
      >
      <i class="fas fa-graduation-cap cursor-pointer text-xl" />
      <small class="truncate" v-text="t('School')"/>
    </ui-link>


    <ui-link
      :class="[
        isRouteActive('/home/settings', true)
          ? 'navpoint text-secondary'
          : 'navpoint text-gray-400',
      ]"
      to="/home/settings"
      >
      <i class="fas fa-gear cursor-pointer text-xl" />
      <small class="truncate" v-text="t('Settings')"/>
    </ui-link>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n()
</script>

<style scoped lang="scss">
.navpoint {
  @apply flex flex-col items-center justify-center !no-underline py-4;

  /* on active apply bg-gray-200 which then eases off if released on a duration of 300ms */
  &:active,
  &:focus,
  &:focus-visible {
    animation: navpointactive 1s ease-in-out forwards;
  }
}

@keyframes navpointactive {
  0% {
    @apply bg-gray-200;
  }
  100% {
    @apply bg-white;
  }
}

</style>
